import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import AccessToken from '@/components/User/AccessToken.vue'
import ChargeHistory from '@/components/Charge/History.vue'
import AutomaticRecharge from '../components/AutomaticRecharge/History.vue'
import Dashboard from '@/components/Dashboard.vue'
import Home from '@/components/Home.vue'
import IntegrationManager from '@/components/Integration/Manager.vue'
import Login from '@/components/User/Login.vue'
import OnboardingWizard from '@/components/Onboarding/OnboardingWizard.vue'
import OrganizationProfile from '@/components/Organization/Profile.vue'
import ChangePassword from '@/components/User/ChangePassword.vue'
import UserProfile from '@/components/User/Profile.vue'
import UsersNew from '@/components/Users/New.vue'
import UsersList from '@/components/Users/List.vue'
import ReportCalls from '@/components/Report/Calls.vue'
import Signup from '@/components/Organization/Signup.vue'
import FinancialData from '@/components/Organization/FinancialData.vue'
import Webphone from '@/components/Webphone/Index.vue'
import IA4COM from '@/components/IA4COM/Index.vue'
import Pricing from '@/components/Subscription/Pricing.vue'
import PricingInformative from '@/components/Subscription/PricingInformative.vue'
import ImpersonationRequest from '@/components/Support/ImpersonationRequest.vue'
import ImpersonationValidate from '@/components/Support/ImpersonationValidate.vue'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: { name: 'home' },
      meta: { requiresAuth: true }
    }, {
      path: '/home',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true }
    }, {
      path: '/user/tokens',
      name: 'accessTokens',
      component: AccessToken,
      meta: { requiresAuth: true }
    }, {
      path: '/subscription',
      name: 'subscription',
      component: Pricing,
      meta: { requiresAuth: true }
    }, {
      path: '/pricing',
      name: 'pricing',
      component: PricingInformative,
      meta: { requiresAuth: true }
    }, {
      path: '/charge/history',
      name: 'chargeHistory',
      component: ChargeHistory,
      meta: { requiresAuth: true }
    }, {
      path: '/charge/automatic',
      name: 'automaticRecharge',
      component: AutomaticRecharge,
      meta: { requiresAuth: true }
    }, {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: { requiresAuth: true }
    }, {
      path: '/integrations/manager',
      name: 'integrationManager',
      component: IntegrationManager,
      meta: { requiresAuth: true }
    }, {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        showHeaderMenuAndFooter: false
      }
    }, {
      path: '/organization/profile',
      name: 'organizationProfile',
      component: OrganizationProfile,
      meta: { requiresAuth: true }
    }, {
      path: '/user/profile',
      name: 'userProfile',
      component: UserProfile,
      meta: { requiresAuth: true }
    }, {
      path: '/users/new',
      name: 'usersNew',
      component: UsersNew,
      meta: { requiresAuth: true }
    }, {
      path: '/users/list',
      name: 'usersList',
      component: UsersList,
      meta: { requiresAuth: true }
    }, {
      path: '/change-password',
      name: 'changePassword',
      component: ChangePassword,
      props: route => ({ access_token: route.query.access_token }),
      meta: {
        requiresAuth: false,
        showHeaderMenuAndFooter: false
      }
    }, {
      path: '/report/calls',
      name: 'reportCalls',
      component: ReportCalls,
      meta: { requiresAuth: true }
    }, {
      path: '/signup',
      name: 'signup',
      component: Signup,
      meta: {
        showHeaderMenuAndFooter: false
      }
    }, {
      path: '/onboarding',
      name: 'onboarding',
      component: OnboardingWizard,
      meta: {
        requiresAuth: true,
        showHeaderMenuAndFooter: false,
        onboardingLayout: true
      }
    }, {
      path: '/financial-data',
      name: 'financialData',
      component: FinancialData,
      props: true,
      meta: { requiresAuth: true }
    }, {
      path: '/support/impersonation',
      name: 'impersonationRequest',
      component: ImpersonationRequest,
      meta: { requiresAuth: true }
    }, {
      path: '/support/impersonation/validate',
      name: 'impersonationValidate',
      component: ImpersonationValidate
    }, {
      path: '/webphone',
      name: 'webphone',
      component: Webphone,
      meta: { requiresAuth: true }
    }, {
      // O IA4COM e servido por outro processo e so aparece embutido aqui — mas
      // a rota exige login como qualquer outra: e do usuario logado que sai a
      // identidade mandada para dentro do iframe.
      //
      // `/assistant`, e NAO `/ia4com`: aquele caminho ja pertence ao proprio
      // app neste dominio — o proxy o entrega ao Nitro antes que a requisicao
      // chegue ao express daqui. Uma rota do portal com aquele nome funcionaria
      // na navegacao interna e sumiria em toda recarga, link direto ou aba
      // nova, servindo o assistente cru e sem casca. Verificado contra
      // portal-staging.api4com.com em 25/08/2026.
      path: '/assistant',
      name: 'ia4com',
      component: IA4COM,
      meta: { requiresAuth: true }
    }
  ]
})

store.dispatch('auth/syncRouter', router)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js